/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2024, Zumper
 * @description AIAssistant Header
 */

import buttonCss from '@zcode-ui/web-zumper-features/src/ListingCard/buttons.module.scss'

export const getVariantCss = (variant?: string, usePrimaryButton?: boolean) => {
  if (variant === 'solid') {
    return buttonCss.solidButton
  }

  if (variant === 'secondary') {
    return buttonCss.secondaryButton
  }

  if (variant === 'ghost') {
    return buttonCss.ghostButton
  }

  if (variant === 'pink') {
    return buttonCss.pinkButton
  }

  if (variant === 'link') {
    return buttonCss.linkButton
  }

  return usePrimaryButton ? buttonCss.solidButton : buttonCss.secondaryButton
}
